import { Link } from 'react-router-dom';

/**
 * Standalone shell for layouts-v2 (no React Admin chrome).
 * Mirrors old Next layouts/layout.jsx isolation so editor menus aren't buried.
 */
export function LayoutsV2Shell({ title = 'Layouts v2', children, scroll = false }) {
  return (
    <div className={`layouts-v2-root layouts-v2-shell${scroll ? ' layouts-v2-shell--scroll' : ''}`}>
      <div className="layouts-v2-shell__bar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <Link to="/">← Panele dön</Link>
          <h1 className="layouts-v2-shell__title">{title}</h1>
        </div>
        <Link to="/layouts-v2">Layout listesi</Link>
      </div>
      <div className="layouts-v2-shell__main">{children}</div>
    </div>
  );
}
